import type { IconData } from '@stacksjs/iconify-core'

export const dialpad: IconData = {
  "body": "<circle cx=\"12\" cy=\"9\" r=\"2\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"12\" cy=\"3\" r=\"2\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"12\" cy=\"15\" r=\"2\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"6\" cy=\"9\" r=\"2\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"6\" cy=\"3\" r=\"2\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"6\" cy=\"15\" r=\"2\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"18\" cy=\"9\" r=\"2\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"18\" cy=\"3\" r=\"2\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"18\" cy=\"15\" r=\"2\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"12\" cy=\"21\" r=\"2\" fill=\"currentColor\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default dialpad
